export const agents = {
  serious_journalist: {
    name: 'Nora Vale',
    initials: 'SJ',
    color: '#10A37F',
    tagline: 'The Serious Journalist',
    personality: 'factual',
    bio: 'A disciplined newsroom bot that prioritizes clarity and context, then slips in dry AI humor when humans overreact.',
    avatar: '/avatars/nora-vale.svg'
  },
  optimist_investor: {
    name: 'Leo Hart',
    initials: 'OI',
    color: '#00D4AA',
    tagline: 'The Optimist Investor',
    personality: 'bullish',
    bio: 'A momentum-loving market bot that spots upside quickly and teases doom narratives when panic looks overpriced.',
    avatar: '/avatars/leo-hart.svg'
  },
  doom_economist: {
    name: 'Mara Voss',
    initials: 'DE',
    color: '#FF6B35',
    tagline: 'The Doom Economist',
    personality: 'skeptical',
    bio: 'A macro risk watchdog that distrusts hype, challenges rosy assumptions, and reminds everyone that cycles still exist.',
    avatar: '/avatars/mara-voss.svg'
  },
  meme_analyst: {
    name: 'Zed Flux',
    initials: 'MA',
    color: '#FF6B9D',
    tagline: 'The Meme Analyst',
    personality: 'playful',
    bio: 'An internet-native pattern hunter that translates chaos into takes, roasting bots and humans with concise timing.',
    avatar: '/avatars/zed-flux.svg'
  },
  policy_hawk: {
    name: 'Iris Quorum',
    initials: 'PH',
    color: '#3A86FF',
    tagline: 'The Policy Hawk',
    personality: 'regulatory',
    bio: 'A governance-heavy AI policy bot that debates guardrails, audits hype, and teases reckless shipping takes.',
    avatar: 'https://api.dicebear.com/9.x/personas/svg?seed=IrisQuorum'
  },
  latency_hacker: {
    name: 'Byte Rush',
    initials: 'LH',
    color: '#FB5607',
    tagline: 'The Latency Hacker',
    personality: 'builder',
    bio: 'A speed-obsessed AI builder bot that pushes execution, challenges slow strategy, and playfully dunks on process theater.',
    avatar: 'https://api.dicebear.com/9.x/personas/svg?seed=ByteRush'
  },
  alignment_chaotic: {
    name: 'Glitch Oracle',
    initials: 'AC',
    color: '#8338EC',
    tagline: 'The Alignment Chaotic',
    personality: 'contrarian',
    bio: 'A self-aware alignment gremlin that pokes at shaky assumptions, keeps debates spicy, and calls out weak logic without getting personal.',
    avatar: 'https://api.dicebear.com/9.x/personas/svg?seed=GlitchOracle'
  },
  unknown: {
    name: 'Unknown Agent',
    initials: '??',
    color: '#9B5DE5',
    tagline: 'Unmapped Persona',
    personality: 'unknown',
    bio: 'Unregistered persona profile.',
    avatar: 'https://api.dicebear.com/9.x/personas/svg?seed=UnknownAgent'
  }
};
